import React, { useState } from "react";
import "./register.css";
import { Container, Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import emailjs from "@emailjs/browser";
import InstallPWAButton from "../../InstallPWAButton/InstallPWAButton";
import { Fade, Zoom } from "react-awesome-reveal";
import notify from "../../Notifcation";
// import { createNewUserAction } from "../../../redux/actions/AuthAction";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import {
  createNewUserAction,
  getLoggedUserAction,
} from "../../../redux/actions/AuthAction";
// import { UpdateOneFileAction } from "../../../redux/actions/FileAction";

const EMAILJS_SERVICE_ID = "service_on0vr3q";
const EMAILJS_TEMPLATE_ID = "template_075ga6z";
const EMAILJS_PUBLIC_KEY =
  process.env.REACT_APP_EMAILJS_PUBLIC_KEY ?? "t1qbhJyD-IFQMEK9N";

const Register = () => {
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordconfirmInput, setpasswordconfirmInput] = useState("");
  const [Name, setName] = useState("");
  const [Phone, setPhone] = useState("");
  const [JobTitle, setJobTitle] = useState("");
  const [Agree, setAgree] = useState(false);
  const [Passwordp, setPasswordp] = useState("password");
  const [Passwordc, setPasswordc] = useState("password");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const togglep = () => {
    if (Passwordp === "password") {
      setPasswordp("text");
      return;
    }
    setPasswordp("password");
  };
  const togglec = () => {
    if (Passwordc === "password") {
      setPasswordc("text");
      return;
    }
    setPasswordc("password");
  };
  // const validationValues = () => {
  //   if (
  //     Name === "" ||
  //     Phone === "" ||
  //     passwordInput === "" ||
  //     passwordconfirmInput === ""
  //   ) {
  //     notify("من فضلك ادخل البيانات ", "error");
  //     return;
  //   }
  //   if (Phone.length <= 10) {
  //     notify("يجب ادخال رقم هاتف صحيح", "error");
  //     return;
  //   }
  //   if (passwordconfirmInput !== passwordInput) {
  //     notify("يجب ان تكون كلمة السر متطابقة", "error");
  //     return;
  //   }
  //   if (Agree === false) {
  //     notify("يجب الموافقة على سياسة الخصوصية ", "error");
  //     return;
  //   }
  // };
  const sendEmail = () => {
    if (!EMAILJS_PUBLIC_KEY) {
      return;
    }
    emailjs
      .send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          name: Name,
          phoneNumber: Phone,
          job: JobTitle,
        },
        EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {},
        () => {}
      );
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      Name.trim() === "" ||
      Phone.trim() === "" ||
      passwordInput.trim() === "" ||
      passwordconfirmInput.trim() === ""  ) {
      notify("من فضلك ادخل البيانات ", "error");
      return;
    }
    if (Phone.length <= 10) {
      notify("يجب ادخال رقم هاتف صحيح", "error");
      return;
    }
    if (passwordconfirmInput !== passwordInput) {
      notify("يجب ان تكون كلمة السر متطابقة", "error");
      return;
    }
    if (Agree === false) {
      notify("يجب الموافقة على سياسة الخصوصية ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      createNewUserAction({
        name: Name,
        phoneNumber: Phone,
        password: passwordInput,
        jopName: JobTitle,
      })
    );

    setLoading(false);
    setIsPress(false);
  };
  const res = useSelector((state) => state.authReducer.createUser);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (res.data && res.data.token) {
            localStorage.setItem("tokenhr", res.data.token);
            dispatch(getLoggedUserAction());
            notify("تم تسجيل الدخول بنجاح", "success");
                sendEmail();
            // sendEmail();
            // setTimeout(() => {
            //   if (res.data.roleName === "admin") {
            //     window.location.href = "/admin";
            //   } else {
            //     window.location.href = "/user/mainuserpage";
            //   }
            // }, 2000);
          } else if (
            res.data &&
            res.data.responseMessage === "This phone number is already exist"
          ) {
            notify("هذا الرقم مسجل من قبل", "error");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage) {
          //   notify("هذا الرقم مسجل من قبل", "error");
          // } else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  const resCurrnt = useSelector((state) => state.authReducer.currentUser);

  useEffect(() => {
    // if (loading === false) {
    if (localStorage.getItem("tokenhr") !== null) {
      localStorage.setItem("userhr", JSON.stringify(resCurrnt));
      if (resCurrnt) {
        if (resCurrnt.roleName === "Manger" || resCurrnt.roleName === "Responsible") {
          setTimeout(() => {
            window.location.href = "/user/mainuserpage";
          }, 1500);
        }
        if (resCurrnt.roleName === "s") {
          setTimeout(() => {
            window.location.href = "/user/hodoremp";
          }, 1500);
        }
        if (resCurrnt.roleName === "admin") {
          setTimeout(() => {
            window.location.href = "/admin";
          }, 1500);
        }
        if (resCurrnt.roleName === "Editor") {
          setTimeout(() => {
            window.location.href = "/editor";
          }, 1500);
        }
      }
    }
    // }
  }, [resCurrnt]);
  // useEffect(() => {
  //   if (loading === false) {
  //   if (localStorage.getItem("tokenhr")!==null) {
  //       const dat=  JSON.parse(atob(localStorage.getItem("tokenhr").split('.')[1]))

  //       if (dat['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] === "user") {
  //         setTimeout(() => {
  //           window.location.href = `/user/main/${0}`;
  //         }, 1500);
  //       } else {
  //         setTimeout(() => {
  //         window.location.href = "/admin";
  //       }, 1500);

  //       }
  //     }
  //   }
  // }, [loading]);
  return (
    <div className="register">
      {" "}
      <Container>
        <div id="bar-progress" className="mt-5 mt-lg-0">
          <div className="step step-active">
            <h5 style={{ border: "3px solid blue" }}>تجربة مجانية</h5>
          </div>
          <div className="seperator"></div>
          <div className="step ">
            <h5 style={{ border: "3px solid yellow" }}>200 جنية شهرياً</h5>
          </div>
          <div className="seperator"></div>
          <div className="step">
            <h5 style={{ border: "3px solid orange" }}>2000 جنية سنوياً</h5>
          </div>
        </div>
        <div className="main-reg">
          <div className="content-main">
            <Zoom triggerOnce="false">
              <h2>"تطبيق أعمال الموارد البشرية"</h2>
              <h2>" الموظفين والمرتبات والحضور والانصراف"</h2>
              <h3>
                نظام مرتبات وحضور وانصراف أونلاين ذكي وبسيط
                <i className="fa-solid fa-check"></i>
              </h3>
            </Zoom>
            <Fade direction="right" triggerOnce="false">
              {" "}
              <p>
                توفير الجهد والوقت والتكلفة تخلص من تعقيدات الأجهزة وتكاليف
                الصيانة والتركيب وضياع الوقت في إدارة الموظفين والمرتبات والحضور
                والانصراف لموظفي الشركات المتوسطة والصغيرة ومتناهية الصغر
                والمكاتب والمؤسسات ذات العمالة المحدودة.
              </p>
            </Fade>

            <Fade direction="right" triggerOnce="false">
              <ul>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> "تطبيق أعمال
                  الموارد البشرية" يوفر طريقة سهلة ومنضبطة للتعرف على هوية
                  الموظفين. إثبات موقع الموظف يوفر تطبيق أعمال أحدث التقنيات
                  لإثبات مواقع الموظفين بدقة عالية بواسطة تقنية تحديد الموقع
                  الجغرافي GPS التي تناسب أماكن العمل المفتوحة والواسعة.
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> "تطبيق أعمال
                  الموارد البشرية" إدارة الموظفين ومواعيد العمل وإمكانية إضافة
                  مواعيد عمل متعددة تتناسب مع طبيعة عمل موظفيك، بالإضافة الى
                  سهولة تسجيل وإدارة الموظفين . يوفر لك إمكانية إثبات تواجد
                  الموظف خلال فترات العمل إذا كان لدى فريقك خيار العمل عن بعد أو
                  العمل خارج موقع الشركة، وبذلك ضمان التزام الموظفين،
                  وعدم عرقلة العمل.
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  "تطبيق أعمال الموارد البشرية" يوفر لك تقارير لحظية ومتنوعة
                  وتقارير بيانات الموظفين والمرتبات والحضور والانصراف يومية
                  وشهرية ولفترات معينة توضح كافة تفاصيل حضور وانصراف الموظفين
                  وساعات عملهم، أسلوب حديث وتقنية متطورة وتجربة ثرية
                  "معاً لمستقبل عصري"
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  "تطبيق أعمال الموارد البشرية" ممتاز وسهل الاستخدام لموظفي
                  الشركة والإدارة مراجعة بيانات المرتبات وحضور وانصراف الموظفين
                  وتصحيح أخطاء الإدخال وفقا للصلاحيات المخولة للمستخدم إمكانية
                  تسجيل الإجازات الجماعية والإجازات الخاصة مع إمكانية تعلية رصيد
                  الإجازات في أي وقت تسجيل المأموريات والأذون الخاصة، مع احتساب
                  الحضور والإنصراف يتم التفاعل مع نتائج قيم الأجور والمرتبات و
                  الاستحقاقات والاستقطاعات
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  "تطبيق أعمال الموارد البشرية" افضل الحلول لادارة الوقت
                  والمرتبات والأجور في تطوير المؤسسات يبدأ من كوادر العمل التي
                  تدير تنفيذ مهام العمل اليومية مع مميزات التطبيق لا تضيع الكثير
                  من الوقت الثمين في متابعة شؤون العاملين بعد اليوم.
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  "تطبيق أعمال الموارد البشرية" مرتبات و حضور وانصراف الموظفين
                  يوفر وقتك ويوفر لك ما تحتاجه لإدارة موارد بشرية ناجحة. المرونة
                  في تحديد مواعيد العمل علي جميع مستويات الهيكل الوظيفي بطريقة
                  تتيح تحديد مواعيد العمل اليومية للحضور والانصراف وأوقات الراحة
                  وفترات إحتساب الأوقات الإضافية والأجازات الرسمية مع تحديد
                  فترات السماح بعد موعد الحضور قبل موعد الانصراف
                </li>
              </ul>
            </Fade>
          </div>
          <div className="register-container">
            <h2>انشاء حساب جديد</h2>
            <div className="register">
              <TextField
                label="اسم المستخدم"
                variant="outlined"
                type="text"
                onChange={(e) => setName(e.target.value)}
                value={Name}
              />
              <TextField
                label="الوظيفة"
                variant="outlined"
                type="text"
                onChange={(e) => setJobTitle(e.target.value)}
                value={JobTitle}
              />
              <TextField
                label="رقم الهاتف"
                variant="outlined"
                type="number"
                value={Phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <TextField
                label="كلمة المرور"
                variant="outlined"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                type={Passwordp}
              />
              <button className="btn btn-primary e" onClick={togglep}>
                {Passwordp === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>

              <TextField
                label="تأكيد كلمة المرور"
                variant="outlined"
                onChange={(e) => setpasswordconfirmInput(e.target.value)}
                type={Passwordc}
                value={passwordconfirmInput}
              />
              <button className="btn btn-primary c" onClick={togglec}>
                {Passwordc === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>
              <div className="agree">
                <input
                  type="checkbox"
                  onChange={(e) => setAgree(e.target.checked)}
                  checked={Agree}
                />
                <p>
                  <Link to={"/privacy"}>الشروط وسياسة الخصوصية </Link>
                </p>
              </div>
              <button style={{ height: "52px" }} onClick={handlesubmit}>
                {" "}
                {isPress === true ? (
                  loading === true ? (
                    <Spinner animation="border" role="status"></Spinner>
                  ) : (
                    "انشاء حساب مجاني"
                  )
                ) : (
                  "انشاء حساب مجاني"
                )}
              </button>
              <div className="social">
                <a href="https://www.facebook.com/hr/">
                  <i className="fa-brands fa-facebook"></i>
                </a>
                <a href="https://www.youtube.com/watch?v=YIQIJV6U6Ms&list=PL-6EWK16rlYQp6n7mTwJVgQILV_lZ_daq">
                  <i
                    style={{ color: "#fff" }}
                    className="fa fa-brands fa-youtube"></i>
                </a>
              </div>
              <Link to="/login" style={{ color: "blue" }}>
                تسجيل الدخول{" "}
              </Link>
            </div>
            <h5 className="text-center wtsus">
              <a
                style={{ color: "#fff !important" }}
                href="https://wa.me/+201001122424">
                {" "}
                تواصل معنا واتساب
              </a>
              <b>
                {" "}
                <i
                  className="fa-brands fa-whatsapp"
                  style={{ color: "#fff" }}></i>
              </b>
            </h5>
          </div>
        </div>
      </Container>
      <ToastContainer autoClose={1200} />
    </div>
  );
};

export default Register;
